import { MediaItem } from '@atom/types/media';
import { getMediaIcon } from '@atom/utilities/iconUtilities';

import classes from './formInstance.module.css';

interface PassedProps {
  media: MediaItem;
}

type Props = PassedProps;

const FileUploadTile = ({ media }: Props) => {
  const { type, fileExtension, fileId, name } = media;
  const mediaIcon = getMediaIcon(type, fileExtension, fileId, name);

  return (
    <div className={classes.mediaTile}>
      {mediaIcon}
      <div className={classes.mediaName}>{`${name}.${fileExtension}`}</div>
    </div>
  );
};

export default FileUploadTile;
